import React from 'react';

import withStyles from '@mui/styles/withStyles';

// @mui/material components
import Dialog from '@mui/material/Dialog';

// @mui/icons-material
import ChecklistIcon from '@mui/icons-material/Assignment';
import CloseIcon from '@mui/icons-material/Close';

// core components
import Card from '../md/components/Card/Card.jsx';
import CardHeader from '../md/components/Card/CardHeader.jsx';
import CardIcon from '../md/components/Card/CardIcon.jsx';
import CardBody from '../md/components/Card/CardBody.jsx';

import VobFormList from './VobFormList';

/*
Call this with
    <VobModal
        show={the condition under which it should show}
        clientId={whatever (0 if on initial call page)}
        clientInfo={{
          clientFirstName: prospectFirstName,
          clientLastName: prospectLastName,
          clientBirthDate: prospectBirthDate,
          clientAddressLine1: prospectAddressLine1,
          clientCity: prospectCity,
          clientZip: prospectZip,
          clientState: prospectState,
        }}
        closeModalFunc={a function for closing the dialog}
    />
*/

const modalStyles = {
  root: {
    '& .MuiFilledInput-input': {
      minWidth: '10em',
    },
  },
  cardIconTitle: {
    marginLeft: '84px',
    marginTop: '-16px',
    fontSize: '3em',
    color: 'black',
  },
  closeButtonDiv: {
    float: 'right',
    marginRight: '12px',
    color: 'gray',
    transform: 'scale(1.8)',
    cursor: 'pointer',
  },
};

class VobModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: undefined,
    };
  }

  render() {
    if (this.state.errorMessage) {
      return <h3>{this.state.errorMessage}</h3>;
    }

    const { classes, show, clientId, clientInfo, closeModalFunc } = this.props;

    return (
      <Dialog className={classes.root} fullWidth={true} maxWidth={'lg'} open={show}>
        <Card>
          <CardHeader color="allevaOrange" icon>
            <div className={classes.closeButtonDiv} onClick={() => closeModalFunc()}>
              <CloseIcon />
            </div>
            <CardIcon className={classes.phoneIcon} color="allevaOrange">
              <ChecklistIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Vob Forms</h4>
          </CardHeader>
          <CardBody>
            <VobFormList clientId={clientId} clientInfo={clientInfo} closeModalFunc={closeModalFunc} />
          </CardBody>
        </Card>
      </Dialog>
    );
  }
}

export default withStyles(modalStyles)(VobModal);
